import { ModuleWithProviders, NgModule } from '@angular/core';
import { GatewayModule } from '../gateways/gateway.module';
import { AuthRepository } from './auth.repository';
import { HealthRepository } from './health.repository';
import { NewsRepository } from './news.repository';
import { ParserModule } from './parsers/parser.module';
import { ResetPasswordRepository } from './reset-password.repository';
import { UserRepository } from './user.repository';
import { VoucherGeneratorRepository } from './voucher-generator.repository';


@NgModule({
  imports: [
    ParserModule.forRoot(),
    GatewayModule.forRoot()
  ]
})

export class RepositoryModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: RepositoryModule,
      providers: [
        AuthRepository,
        UserRepository,
        ResetPasswordRepository,
        HealthRepository,
        NewsRepository,
        VoucherGeneratorRepository
      ]
    };
  }
}
